<template>
  <div class="kantei-form">
    <form :action="action" :method="method" @submit="showLoading = true">
      <input type="hidden" name="_token" :value="token" />

      <!-- STEP 1 -->
      <step-box
        :step="1"
        title="占いたいこと"
        :current-step="currentStep"
      >
        <input-radio
          name="themeq"
          design-type="image"
          :form-setting="formSetting.themeq.items"
          :inputed-data="inputedData.themeq"
          @change="changeThemeq" />
      </step-box>

      <!-- STEP 2 -->
      <step-box
        v-if="currentStep >= 2"
        :step="2"
        title="さらに詳しく"
        :current-step="currentStep"
      >
        <input-radio
          name="keyword"
          design-type="frame"
          :form-setting="formSetting.keyword[inputedData.themeq].items"
          :inputed-data="inputedData.keyword"
          @change="(value) => {inputedData.keyword = value}" />
      </step-box>

      <!-- STEP 3 -->
      <step-box
        v-if="currentStep >= 3"
        :step="3"
        title="お悩みを書いてください"
        :subText="'（' + formSetting.worried.maxLength + '文字）'"
        :current-step="currentStep"
      >
        <base-attention
          v-if="Number(inputedData.worried).length > Number(formSetting.worried.maxLength)"
          class="kantei-form__attention--worried"
          :text="'制限文字数を超えています。<br>' + formSetting.worried.maxLength + '文字以内で入力してください。'"
        />
        <input-textarea
          name="worried"
          :form-setting="formSetting.worried"
          :inputed-data="inputedData.worried"
          @input="(value) => {inputedData.worried = value}" />
      </step-box>

      <!-- STEP 4 -->
      <step-box
        v-if="currentStep >= 4"
        :step="4"
        title="占いに使う情報入力"
        :current-step="currentStep"
        :valid="!isDisabledSubmitButton"
      >
        <dl class="user-data">
          <dt class="user-data__title">
            ニックネーム
            <span class="user-data__label">必須</span>
          </dt>
          <dd class="user-data__data">
            <input
              name="nickname"
              type="text"
              class="input-text"
              maxlength="15"
              :value="inputedData.nickname"
              @input="changeValue($event.target.value.trim(), 'nickname')"
            >
          </dd>
          <dt class="user-data__title">
            生年月日
            <span class="user-data__label">必須</span>
          </dt>
          <dd class="user-data__data user-data__data--birth">
            <input type="hidden" name="birthday" :value="birthday" />
            <select-box
              class="select-box--year"
              data-type="birth"
              :form-setting="birthDay[0]"
              :inputed-data="inputedData.birthYear"
              @change="value => changeValue(value, 'birthYear')"
            />
            <select-box
              data-type="birth"
              :form-setting="birthDay[1]"
              :inputed-data="inputedData.birthMonth"
              @change="value => changeValue(value, 'birthMonth')"
            />
            <select-box
              data-type="birth"
              :form-setting="birthDay[2]"
              :inputed-data="inputedData.birthDay"
              @change="value => changeValue(value, 'birthDay')"
            />
          </dd>
          <dt class="user-data__title">
            性別
            <span class="user-data__label">必須</span>
          </dt>
          <dd class="user-data__data">
            <input-radio
              name="gender"
              design-type="icon"
              :form-setting="formSetting.gender"
              :inputed-data="inputedData.gender"
              @change="value => changeValue(value, 'gender')" />
          </dd>
          <dt class="user-data__title">出生時間</dt>
          <dd class="user-data__data">
            <input type="hidden" name="birthtime" :value="birthtime" />
            <select-box
              data-type="time"
              :form-setting="Number(formSetting.birthTime.hours)"
              :inputed-data="inputedData.birthHours"
              @change="value => changeValue(value, 'birthHours')"
            />
            <select-box
              data-type="time"
              :form-setting="Number(formSetting.birthTime.minutes)"
              :inputed-data="inputedData.birthMinutes"
              @change="value => changeValue(value, 'birthMinutes')"
            />
          </dd>
          <dt class="user-data__title">出生地</dt>
          <dd class="user-data__data">
            <select-box
              name="from_pref"
              :form-setting="formSetting.fromPref"
              :inputed-data="inputedData.fromPref"
              @change="value => changeValue(value, 'fromPref')"
            />
          </dd>
          <dt v-if="showPartnerBirth" class="user-data__title">
            相手の生年月日
            <span class="user-data__label">必須</span>
          </dt>
          <dd v-if="showPartnerBirth" class="user-data__data user-data__data--birth">
            <input type="hidden" name="target_birthday" :value="targetBirthday" />
            <select-box
              class="select-box--year"
              data-type="birth"
              :form-setting="targetBirthDay[0]"
              :inputed-data="inputedData.partnerBirthYear"
              @change="value => changeValue(value, 'partnerBirthYear')"
            />
            <select-box
              data-type="birth"
              :form-setting="targetBirthDay[1]"
              :inputed-data="inputedData.partnerBirthMonth"
              @change="value => changeValue(value, 'partnerBirthMonth')"
            />
            <select-box
              data-type="birth"
              :form-setting="targetBirthDay[2]"
              :inputed-data="inputedData.partnerBirthDay"
              @change="value => changeValue(value, 'partnerBirthDay')"
            />
          </dd>
        </dl>
      </step-box>

      <submit-button
        v-if="currentStep >= 4"
        type="submit"
        :disabled="Boolean(isDisabledSubmitButton + showLoading)"
      />

      <app-loading :is-loading="showLoading" />

    </form>
  </div>
</template>

<script>
import StepBox from "./StepBox"
import InputRadio from "./InputRadio"
import InputTextarea from "./InputTextarea"
import SelectBox from "./SelectBox"
import SubmitButton from "../partials/SubmitButton"
import BaseAttention from "../common/Attention"

export default {
  name: "EntryKanteiForm",
  components: {
    StepBox,
    InputRadio,
    InputTextarea,
    SelectBox,
    SubmitButton,
    BaseAttention
  },
  props: {
    formSetting: {
      type: Object,
      default () {
        return {}
      }
    },
    userData: {
      type: Object,
      default () {
        return {}
      }
    },
    action: String,
    method: String,
    token: String
  },
  data() {
    return {
      // 入力されたデータ
      inputedData: {
        themeq: '',
        keyword: '',
        worried: '',
        nickname: '',
        birthYear: '00',
        birthMonth: '00',
        birthDay: '00',
        gender: '',
        birthHours: 0,
        birthMinutes: 0,
        fromPref: '',
        partnerBirthYear: '00',
        partnerBirthMonth: '00',
        partnerBirthDay: '00',
      },
      // 生年月日の設定値
      birthDay: [[], 0, 0],
      // 相手の生年月日の設定値
      targetBirthDay: [[], 0, 0],
      // loading の表示
      showLoading: false
    }
  },
  computed: {
    /**
     * 現在のステップ
     * @return {Number}
     */
    currentStep () {
      // 初期値
      let result = 1
      // 各ステップ
      const step1 = this.inputedData.themeq
      const step2 = this.inputedData.keyword
      const len = this.inputedData.worried.length
      const step3 = 0 < len && len <= Number(this.formSetting.worried.maxLength)
      if ( step1 && step2 && step3 ) {
        result = 4
      } else if ( step1 && step2 ) {
        result = 3
      } else if ( step1 ) {
        result = 2
      }
      return result
    },
    /**
     * 入力された値から、生年月日を作る
     * @return {String} YYYYMMDD
     */
    birthday () {
      const YYYY = ('0000' + this.inputedData.birthYear).slice(-4)
      const MM = ('00' + this.inputedData.birthMonth).slice(-2)
      const DD = ('00' + this.inputedData.birthDay).slice(-2)
      return YYYY + MM + DD
    },
    /**
     * 入力された値から、出生時間を作る
     * @return {String} HHii
     */
    birthtime () {
      // どちらかが falsy な場合は ''
      if (!this.inputedData.birthHours || !this.inputedData.birthMinutes) {
        return ''
      }
      const HH = ('00' + this.inputedData.birthHours).slice(-2)
      const ii = ('00' + this.inputedData.birthMinutes).slice(-2)
      return HH + ii
    },
    /**
     * 入力された値から、相手の生年月日を作る
     * @return {String} YYYYMMDD
     */
    targetBirthday () {
      const YYYY = ('0000' + this.inputedData.partnerBirthYear).slice(-4)
      const MM = ('00' + this.inputedData.partnerBirthMonth).slice(-2)
      const DD = ('00' + this.inputedData.partnerBirthDay).slice(-2)
      return YYYY + MM + DD
    },
    /**
     * 相手の生年月日を表示する
     * @return {Boolean}
     */
    showPartnerBirth () {
      return /相性|相手の気持ち|二人の未来|相手/.test(this.inputedData.keyword) ? true : false
    },
    /**
     * 「次へ」ボタンの disabled を返す
     * @return {Boolean} true => disabled
     */
    isDisabledSubmitButton () {
      const data = this.inputedData
      let result = !data.nickname +
                   !data.gender
      // 生年月日の真偽（存在する日付か、未来日ではないか）
      const birthDate = window.moment(`${data.birthYear}-${data.birthMonth}-${data.birthDay}`, 'YMD')
      result += !birthDate.isValid() + birthDate.isAfter(window.moment())
      // 相手の生年月日の真偽（存在する日付か、未来日ではないか）
      if (this.showPartnerBirth) {
        const partnerBirthDate = window.moment(`${data.partnerBirthYear}-${data.partnerBirthMonth}-${data.partnerBirthDay}`, 'YMD')
        result += !partnerBirthDate.isValid() + partnerBirthDate.isAfter(window.moment())
      }
      return Boolean(result)
    }
  },
  created () {
    // 登録済みデータ代入
    const inp = this.inputedData
    const user = this.userData
    inp.themeq = user.themeq || ''
    inp.keyword = user.keyword || ''
    inp.worried = user.worried || ''
    inp.nickname = user.nickname || ''
    inp.birthYear = user.birthDay ? String(user.birthDay).slice(0, 4) : '00'
    inp.birthMonth = user.birthDay ? String(user.birthDay).slice(4, 6) : '00'
    inp.birthDay = user.birthDay ? String(user.birthDay).slice(-2) : '00'
    inp.gender = user.gender || ''
    inp.birthHours = user.birthTime ? String(user.birthTime).slice(0, 2) : 0
    inp.birthMinutes = user.birthTime ? String(user.birthTime).slice(-2) : 0
    inp.fromPref = user.fromPref || ''
    inp.partnerBirthYear = user.targetBirthday ? String(user.targetBirthday).slice(0, 4) : '00'
    inp.partnerBirthMonth = user.targetBirthday ? String(user.targetBirthday).slice(4, 6) : '00'
    inp.partnerBirthDay = user.targetBirthday ? String(user.targetBirthday).slice(-2) : '00'
    // 生年月日の設定
    this.makeBirthDateYear ()
    this.makeBirthDateMonth ()
    this.makeBirthDateMonth (true)
    this.makeBirthDateDay ()
    this.makeBirthDateDay (true)
  },
  methods: {
    /**
     * テーマを変更
     * @return {void}
     */
    changeThemeq (value) {
      this.inputedData.themeq = value
      // 整合性が取れなくなると困るので、キーワードをクリア
      this.inputedData.keyword = ''
    },
    /**
     * 始まりの年〜今年までの配列を作って代入
     * @return {void}
     */
    makeBirthDateYear () {
      const currentYear = new Date().getFullYear()
      const fromYear = Number(this.formSetting.beginningYear)
      for (let i = fromYear; i <= currentYear; i++) {
        this.birthDay[0].push(i)
        this.targetBirthDay[0].push(i)
      }
    },
    /**
     * その年の最終月を代入　
     * @return {void}
     */
    makeBirthDateMonth (isPartner) {
      const inputYear = Boolean(isPartner) ? 'partnerBirthYear' : 'birthYear'
      const settingPartner = Boolean(isPartner) ? 'targetBirthDay' : 'birthDay'
      const today = new Date()
      const year = this.inputedData[inputYear] || today.getFullYear()
      if (today.getFullYear() === year) {
        this[settingPartner][1] = today.getMonth() + 1
      } else {
        this[settingPartner][1] = 12
      }
    },
    /**
     * 当月の最終日を代入　
     * @return {void}
     */
    makeBirthDateDay (isPartner) {
      const inputYear = Boolean(isPartner) ? 'partnerBirthYear' : 'birthYear'
      const inputMonth = Boolean(isPartner) ? 'partnerBirthMonth' : 'birthMonth'
      const settingPartner = Boolean(isPartner) ? 'targetBirthDay' : 'birthDay'
      // 入力されたデータがない場合は、今日の Date を使用
      const today = new Date()
      const year = this.inputedData[inputYear] || today.getFullYear()
      const month = Number(this.inputedData[inputMonth]) || today.getMonth() + 1
      // 当月の月末日を取得
      let lastDay = new Date(year, month, 0).getDate()
      // もし月末日が未来日なら今日の日付にする
      if (today.getFullYear() === year && today.getMonth() + 1 === month) {
        lastDay = today.getDate()
      }
      this[settingPartner][2] = lastDay
    },
    /**
     * ユーザーが入力・変更したデータを設定
     * @return {Void} inputedData に反映
     */
    changeValue (value, target) {
      this.inputedData[target] = value
      if (/birthYear|birthMonth|birthDay/.test(target)) {
        this.makeBirthDateMonth ()
        this.makeBirthDateDay ()
      } else if (/partnerBirthYear|partnerBirthMonth|partnerBirthDay/.test(target)) {
        this.makeBirthDateMonth (true)
        this.makeBirthDateDay (true)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.kantei-form {
  color: $col_base_black;
  padding: 30px 10px 0;
  &__attention {
    &--worried {
      margin-bottom: 15px;
    }
  }
}
.user-data {
  display: block;
  margin: 0;
  &__title {
    display: block;
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 8px;
  }
  &__data {
    display: block;
    margin: 0;
    &--birth {
      display: flex;
      .select-box {
        flex: 1 1 auto;
        min-width: 63px;
        margin-right: 5px;
        &:last-child {
          margin-right: 0;
        }
        &--year {}
      }
    }
  }
  &__data + &__title {
    margin-top: 20px;
  }
  &__label {
    display: inline-block;
    padding: 2px 5px;
    color: $col_white;
    font-weight: normal;
    font-size: 10px;
    line-height: 1;
    vertical-align: 1px;
    border-radius: 10px;
    background-color: #FF7497;
  }
}
.input-text {
  width: 100%;
  padding: 11px 13px;
  border: 1px solid $col_temp_gray3;
  border-radius: 5px;
  font-size: 14px;
  text-align: justify;
  background: none;
}
.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 100001;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/EntryKanteiForm.vue